import * as React from "react";
import Input from "../Input-new/Input";
import Dropdown from "../Dropdown/Dropdown";
import DualRange from "../DualRange";
import SelectTeam from "../SelectTeam-new/SelectTeam";
import Textarea from "../Textarea-new/Textarea";
import { getTenantSubcategoryMT, getTenantSubcategorySTNL } from "../../utils";

const BuyerInfo = ({
  data,
  handleChangeInput,
  handleChangeDropdown,
  isExists,
  viewMode,
  deleted,
  handleParentDropdownChange
}) => {
  return (
    <div className="Buyer-info">
      <div className="Buyer-info_column">
      {(isExists) && <p className="errorText"> Given Buyer Details Already Exists</p>}
        <Input
          className="Buyer-info_column_item"
          required
          valueType="text"
          name="first_name"
          label="First Name"
          value={data.first_name}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-info_column_item"
          required
          valueType="text"
          name="last_name"
          label="Last Name"
          value={data.last_name}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-info_column_item"
          required={data.contact_type && data.contact_type.includes("Team")}
          valueType="phone"
          name="phone"
          label="Phone"
          value={data.phone}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-info_column_item"
          required={data.contact_type && data.contact_type.includes("Team")}
          valueType="email"
          name="email"
          label="Email"
          value={data.email}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Dropdown
          className="Buyer-info_column_item"
          data={data}
          optionsType="profiles"
          value={data.profile}
          valueKey="profile"
          label="Profile"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Dropdown
          className="Buyer-info_column_item"
          data={data}
          optionsType="buyerStatus"
          value={data.status}
          valueKey="status"
          label="Buyer Status"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />
          <Dropdown
          className="Buyer-info_column_item"
          dropdownType='multiple'
          optionsType='contactType'
          value={Array.isArray(data.contact_type) ? data.contact_type.join(",") : data.contact_type || ""}
          valueKey='contact_type'
          label='Contact Type'
          data={data}
          handleParentChange={handleParentDropdownChange}
          viewMode={viewMode}
        />
        {data.contact_type && (data.contact_type.includes("Lender")) ?
          <Input
            className="Buyer-info_column_item"
            name="name"
            required
            label="Lender Name"
            value={data.name}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          />
          : ""
        }
        {data.contact_type && (data.contact_type.includes("Lender")) ?
          <Textarea
            className="Buyer-info_column_item"
            required
            valueType="text"
            inputType="textarea"
            name="notes"
            label="Notes"
            value={data.notes}
            maxWidth="100%"
            viewMode={viewMode}
            handleParentChange={handleChangeInput}
            deleted={deleted}
          /> : ""
        }
        {/* {data.contact_type && (data.contact_type.includes("Lender") || data.contact_type.includes("Tenant")) ?
          <Input
            className="Buyer-info_column_item"
            name="name"
            label="Name"
            value={data.name}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          />
          : ""
        } */}
        <div
          className={`Buyer-info_column_item last-modified ${
            deleted ? "deleted" : ""
          }`}
        >
          Last modified on: {data.arcimedes_modified}
        </div>
      </div>
      <div className="Buyer-info_column">
        {data.status && (
          <React.Fragment>
            <Dropdown
              className="Buyer-info_column_item"
              dropdownType="multiple"
              optionKey="code"
              optionLabelKey="name"
              data={data}
              optionsType="category"
              value={data.category}
              valueKey="category"
              label="Category"
              handleParentChange={handleChangeDropdown}
              viewMode={viewMode}
              deleted={deleted}
            />
            <Dropdown
              className="Buyer-info_column_item"
              optionKey="code"
              dropdownType="multiple"
              optionLabelKey="name"
              data={data}
              optionsType="type"
              value={data.type}
              valueKey="type"
              label="Type"
              handleParentChange={handleChangeDropdown}
              viewMode={viewMode}
              deleted={deleted}
            />
            
            {
                data.type=== "STNL" && data.category && !data.category.includes(',') && getTenantSubcategorySTNL({data, handleChangeDropdown, viewMode, deleted, className : "Buyer-info_column_item"})
            }
            {
                data.type=== "MT" && data.category && !data.category.includes(',') && getTenantSubcategoryMT({data, handleChangeDropdown, viewMode, deleted, className : "Buyer-info_column_item"})
            }
        
            <Dropdown
              className="Buyer-info_column_item"
              dropdownType="multiple"
              data={data}
              optionsType="buyer-market"
              value={data.market}
              valueKey="market"
              label="Market"
              handleParentChange={handleChangeDropdown}
              viewMode={viewMode}
              deleted={deleted}
            />
            <DualRange
              className="Buyer-info_column_item"
              minValue={data.price_min}
              maxValue={data.price_max}
              minName="price_min"
              maxName="price_max"
              valueType="integer"
              label="Price Range"
              handleParentChange={handleChangeInput}
              viewMode={viewMode}
              deleted={deleted}
              isDollar
            />
            <DualRange
              className="Buyer-info_column_item"
              minValue={data.cap_rate_min}
              maxValue={data.cap_rate_max}
              minName="cap_rate_min"
              maxName="cap_rate_max"
              valueType="percent"
              label="Cap Rate Range"
              handleParentChange={handleChangeInput}
              viewMode={viewMode}
              deleted={deleted}
            />
            <SelectTeam
              className="Buyer-info_column_item"
              value={data.strive_agent}
              valueKey="strive_agent"
              label="Agent"
              data={data}
              handleParentChange={handleChangeDropdown}
              viewMode={viewMode}
              deleted={deleted}
            />
            {!data.contact_type.includes("Lender")  &&
            <Textarea
              className="Buyer-info_column_item"
              label="Notes"
              name="notes"
              value={data.notes}
              maxWidth="100%"
              handleParentChange={handleChangeInput}
              viewMode={viewMode}
              deleted={deleted}
            />
            }
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default BuyerInfo;
